import { AxiosResponse } from "axios";
import { $api } from "../../shared/api";

export const checkQuestionAnswer = (answerData: any) => {
  return $api.post("/moodle/check_question_answer", answerData);
};
export const finish_attempt = (finishData: any) => {
  return $api.post("/moodle/finish_attempt", finishData);
};
export const startAttempt = (startData: any) => {
  return $api.post("/moodle/start_attempt", startData);
};
export const getQuizzesByCourseId = (courseId: any) => {
  return $api.get(`/moodle/get_quizzes_by_course_id/${courseId}`);
};
export const getCourseBlocks = (courseId: any) => {
  return $api.get(`/moodle/get_course_blocks/${courseId}`);
};
export const getQuizUserAttempts = (quizId: any) => {
  return $api.get(`/moodle/get_quiz_user_attempts/${quizId}`);
};
export const getInProgressQuiz = (courseId: any, attemptId: any) => {
  return $api.get(`/moodle/get_inprogress_quiz/${courseId}/${attemptId}`);
};

export const startGame = (
  userId: string,
  courseId: number | string
): Promise<AxiosResponse<any, any>> => {
  return $api.post("/game/start_game", {
    user_id: userId,
    course_id: courseId,
  });
};

export const nextGameStage = (
  userId: string,
  courseId: number | string
): Promise<AxiosResponse<any, any>> => {
  return $api.post("/game/next_game_stage", {
    user_id: userId,
    course_id: courseId,
  });
};

export const restartGame = (
  userId: string,
  courseId: number | string
): Promise<AxiosResponse<any, any>> => {
  return $api.post("/game/restart_game", {
    user_id: userId,
    course_id: courseId,
  });
};
